module.exports = __webpack_public_path__ + "img/whatsapp.d89731b4.svg";